<template>
  <div class="integration-list" :class="profile && profile.company_data ? '' : 'mt-none'">
    <div class="box">

      <div class="integrations">
        <div class="title"><p>Chave de integração</p></div>
        <ClipboardCopy :clipboardText="keys.authenticity_token"></ClipboardCopy>
      </div>


      <div class="integrations">
        <div
          class="title"
          :class="integrations !== null && integrations.length > 0 ? '--minor' : ''"
          v-if="integrations !== null && integrations.length > 0" >
          <p>Integrações ativas</p>
        </div>
        <div class="content">
          <div 
            class="list list--cards" 
            v-if="activeIntegrations !== null && activeIntegrations.length > 0"
            >
            <div 
              v-for="integration in activeIntegrations"
              v-bind:key="integration.id">
              <div 
                v-if="integration.type"
                :key="integration.type"
                class="integration__card"
                v-on:click="handleEdit(integration.id)"
                >
                <img :src="getSvgStoreUrl(`${integration.type}`)" :alt="integration.type" />
                <p v-if="integration.type == 'vtexlegacy'">VTEX <small>API</small></p>
                <p v-else-if="integration.type == 'vtexio'">VTEX <small>IO</small></p>
                <p v-else-if="integration.type == 'nuvemshop'">Nuvemshop<br /><small>{{integration.nuvemshop.storeid}}</small></p>
                <p v-else-if="integration.type == 'shopify'">Shopify<br /><small>{{integration.shopify.storeid}}</small></p>
                <p v-else-if="integration.type == 'googleads'">
                  Google Ads<br />
                  <small v-if="integration.google_ads.selected_customer_id">{{integration.google_ads.selected_customer_name}} ({{integration.google_ads.selected_customer_id}})</small>
                  <small v-else>(Selecione a conta)</small>
                </p>
                <p v-else>{{ integration.type }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="integrations" v-if="alert !== null">
        <div class="alert">
          <p>{{alert}}</p>
        </div>
      </div>

      <div class="integrations" v-if="success !== null">
        <div class="alert --success">
          <p>{{success}}</p>
        </div>
      </div>

      <div class="integrations">
        <div class="title">
          <p>Integrações disponíveis</p>
        </div>

        <div class="content__cards">
          <div 
            v-if="!findActiveIntegration('vtexlegacy')"
            class="integration__card" 
            v-on:click="hasEcommerceIntegration ? openAlert() : openModal('showModal')">
            <img src="~@/assets/images/icones/logo-vtex.svg" alt="VTEX" />
            <p>VTEX</p>
          </div>

          <!-- <div 
            v-if="!findActiveIntegration('nuvemshop')"
            class="integration__card" 
            v-on:click="hasEcommerceIntegration ? openAlert() : openModal('showModalNuvemshop')">
            <img src="~@/assets/images/icones/logo-nuvemshop.svg" alt="Nuvemshop" />
            <p>Nuvemshop</p>
          </div> -->

          <!-- <div 
            v-if="!findActiveIntegration('shopify')"
            class="integration__card" 
            v-on:click="hasEcommerceIntegration ? openAlert() : openModal('showModalNuvemshop')">
            <img src="~@/assets/images/icones/logo-shopify.svg" alt="Shopify" />
            <p>Shopify</p>
          </div> -->

          <div 
            v-if="!findActiveIntegration('googleads')"
            class="integration__card" 
            v-on:click="hasAdsIntegration ? openAlert() : openModal('showModalGoogleAds')">
            <img src="~@/assets/images/icones/logo-googleads.svg" alt="Google Ads" />
            <p>Google Ads</p>
          </div>

          <!-- <div class="integration__card">
            <img src="~@/assets/images/icones/logo-vtex.svg" alt="VTEX" />
            <p>VTEX <small>IO</small></p>
          </div> -->

          <!-- <div class="integration__card">
            <img src="~@/assets/images/icones/logo-tray.svg" alt="TRAY" />
            <p>Tray</p>
          </div> -->
        </div>

      </div>

      <div class="integrations">
        <div class="subtitle">
          <p>Disponíveis em breve...</p>
        </div>

        <div class="content__cards">
          <div 
            class="integration__card" >
            <img src="~@/assets/images/icones/logo-shopify.svg" alt="Shopify" />
            <p>Shopify</p>
          </div>

          <!-- <div 
            class="integration__card" >
            <img src="~@/assets/images/icones/logo-googleads.svg" alt="Google Ads" />
            <p>Google Ads</p>
          </div> -->
        </div>
      </div>
      

    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ClipboardCopy from "@/components/clipboard-copy/ClipboardCopy.vue";
import { getSvgStoreUrl } from "../../utils/url";

export default {
  props: ["integrations", "keys"],
  components: {
    ClipboardCopy,
  },
  data() {
    return {
      list: [],
      seeactives: true,
      seeadd: true,
      buttonenabled: false,
      alert: null,
      success: null,

      activeIntegrations: null,

      hasEcommerceIntegration: false,
      hasAdsIntegration: false,

      nuvemshop: null,
      shopify: null,
      vtexLegacy: null,
      vtexIo: null,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.user.dadosCompletos,
    }),
  },
  mounted() {
    this.closeModal("showModal");
    this.closeModal("showModalNuvemshop");
    this.closeModal("showModalShopify");
    this.closeModal("showModalGoogleAds");
    this.verifyParamError();
  },
  methods: {
    getSvgStoreUrl,
    handleEdit(id) {
      this.$emit("update:actives", true);
      this.$emit("update:edit", id);
      this.$emit("AddOpen", true);
      this.buttonenabled = true;
    },
    openModal(platform) {
      console.log('openModal', platform)
      this.$emit(platform, true);
    },
    closeModal(platform) {
      this.$emit(platform, false);
    },
    findActiveIntegration(type) {
      const exists = this.integrations.filter(i => i.type === type).length > 0;
      return exists;
    },

    openAlert(msg) {
      this.alert = msg ? msg : 'Já existe uma integração ativa para esta categoria.';
      setTimeout(() => this.alert = null, 10000)
    },

    openSuccess(msg) {
      this.success = msg;
      setTimeout(() => this.success = null, 10000)
    },

    cleanURLSearchParams(param) {
      let url = new URL(window.location.href);
      url.searchParams.delete(param);

      // Atualiza a URL sem recarregar a página
      window.history.replaceState({}, document.title, url.pathname + url.search);
    },

    verifyParamError() {
      let params = new URLSearchParams(document.location.search);
      
      let error_message = params.get("error_message");
      if (error_message) {
        this.openAlert(error_message);
        this.cleanURLSearchParams('error_message');
      }
      
      let success_message = params.get("success_message");
      if (success_message) {
        this.openSuccess(success_message);
        this.cleanURLSearchParams('success_message');
      }
    }
  },
  watch: {
    integrations(data) {
      console.log('watch integrations', data)
      this.activeIntegrations = (data && data.length > 0) ? data : null;
    },
    activeIntegrations(data) {
      data.map(i => {
        console.log('activeIntegrations map i', i)

        // const ANALYTICS = 'analytics';
        // const CRM = 'crm';
        // const PAYMENTS = 'payments';
        // const LOGISTICS = 'logistics';
        // const MARKETPLACE = 'marketplace';

        if (i.category == 'ecommerce')  this.hasEcommerceIntegration = true;
        if (i.category == 'ads')        this.hasAdsIntegration = true;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.integration-list {
  max-width: 585px;
  width: 100%;
  height: auto;
  background-color: white;
  border-radius: 10px;
  padding: 18px;
  padding-bottom: 25px;
  margin-top: 65px;

  .integrations {
    margin: 25px 15px;
  }

  .box {
    height: 100%;

    .alert {
      background-color: $red;
      color: white;

      &.--success {
        background-color: $green;
      }

      p {
        color: white;
      }
    }

    .title {
      // padding-bottom: 61px;
      padding: 5px 0 20px;
      &.--minor {
        padding-bottom: 20px;
      }
      p {
        font-size: 18px;
        font-family: $font__main;
        font-weight: bolder;
        color: #000000;
      }
    }
    .subtitle {
      font-size: 14px;
      line-height: 1.4;
      font-family: $font__main;
      font-weight: 500;
      color: #747474;
      margin-bottom: 20px;
    }

    .content {
      height: 65%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &__cards {
        display: flex;
        width: 100%;
      }
      .list {
        cursor: pointer;
        &--cards {
          display: flex;
          // flex-direction: column;
          flex-wrap: wrap;
          gap: 1rem;
        }
        &__title {
          font-size: 18px;
        }
        &__icone {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &__cod {
          color: #9f9f9f;
        }
      }
    }

    .integration__card {
      align-items: center;
      background: white;
      border: 1px solid lightgray;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      min-height: 106px;
      margin-right: 1%;
      justify-content: center;
      padding: 10px;
      width: 120px;
      text-align: center;

      &:hover {
        border-color: #1f1f1f;
      }

      img {
        height: 30px;
        max-width: 100%;
        margin: 13px;
      }

      p {
        small {
          margin-top: .4rem;
          font-weight: bold;
        }
      }
    }

    .add-button {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 335px;
      width: 100%;
      height: 51px;
      border-radius: 5px;
      background-color: #41a7ff;
      cursor: pointer;

      a {
        border: none;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        font-family: $font__main;
      }
    }

    .disabled {
      pointer-events: none;
      border: 1px solid #999999;
      background-color: #cccccc;
      color: #965b5b;
    }
  }
}

@media only screen and (max-width: 1400px) {
}

@media only screen and (max-width: 700px) {
}
</style>
